enum ClientApiVersion {
  Default = 0,
  Supports400ErrorCode = 1,
  SupportsNewAuthCall = 2,
  SupportsNewUserLocationFormat = 3,
  SupportsErrorMessage = 4,
}

export { ClientApiVersion };
